export default "__VITE_ASSET__B$RG6paX__"